import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { changeAllSubSwitchesByNotifIdAndTaskTypeId } from 'features/views/settings/actions';

export const ToggleAllButtons = ({ items = [] }) => {
	const dispatch = useDispatch();

	const handleToggleAllSubswitches = useCallback(
		(enabled) => () => {
			dispatch(changeAllSubSwitchesByNotifIdAndTaskTypeId(items, enabled));
		},
		[dispatch, items],
	);

	return (
		<Stack spacing={1} direction="row">
			<Button variant="contained" onClick={handleToggleAllSubswitches(true)}>
				{getLabelMessage('settings:selectAll')}
			</Button>
			<Button variant="outlined" onClick={handleToggleAllSubswitches(false)}>
				{getLabelMessage('settings:unselectAll')}
			</Button>
		</Stack>
	);
};

ToggleAllButtons.propTypes = {
	items: PropTypes.array,
};

export default ToggleAllButtons;
